import { Order, Route } from "@web-app/types";

import RouteTimeline from "./RouteTimeline";

type RouteTimelineTabProps = {
  orders: Order[];
  route: Route;
};

export default function RouteTimelineTab({
  orders,
  route,
}: RouteTimelineTabProps) {
  return (
    <div className="px-6 overflow-y-auto max-h-[calc(100vh-150px)]">
      <RouteTimeline orders={orders} route={route} />
    </div>
  );
}
